module.exports = __webpack_public_path__ + "img/about_left.f68ef56f.png";